import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট


const apiUrl = config.apiUrl;

const CreateCommunity = ({ onCommunityCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    title: "",
    subtitle: "",
    facebook_group_link: "",
    icon: "",
    benefits: "",
    button_text: "",
    button_icon: ""
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

    // Quill এর জন্য মডিউল কনফিগারেশন
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ReactQuill এর জন্য আলাদা হ্যান্ডলার
  const handleQuillChange = (value) => {
    setFormData(prev => ({ ...prev, benefits: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/communities`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onCommunityCreated) {
        onCommunityCreated();
      }
      
      // Reset form after successful submission
      setFormData({
        slug: "",
        title: "",
        subtitle: "",
        facebook_group_link: "",
        icon: "",
        benefits: "",
        button_text: "",
        button_icon: ""
      });
      
      alert("Community created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the Community.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Community</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., our-community"
          />
        </div>

        <div>
          <label className="block mb-1">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., Our Awesome Community"
          />
        </div>

        <div>
          <label className="block mb-1">Subtitle:</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., Join our growing community"
          />
        </div>

        <div>
          <label className="block mb-1">Facebook Group Link:</label>
          <input
            type="url"
            name="facebook_group_link"
            value={formData.facebook_group_link}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., https://facebook.com/groups/our-community"
          />
        </div>

        <div>
          <label className="block mb-1">Icon (class or URL):</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., fas fa-users or image URL"
          />
        </div>

         <div>
          <label className="block mb-1">Benefits:</label>
          <ReactQuill
            theme="snow"
            value={formData.benefits}
            onChange={handleQuillChange}
            modules={modules}
            formats={formats}
            className="bg-white rounded"
            placeholder="List the benefits of joining the community..."
          />
        </div>


        <div>
          <label className="block mb-1">Button Text:</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., Join Now"
          />
        </div>

        <div>
          <label className="block mb-1">Button Icon (class or URL):</label>
          <input
            type="text"
            name="button_icon"
            value={formData.button_icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., fas fa-sign-in-alt"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create Community"}
        </button>
      </form>
    </div>
  );
};

export default CreateCommunity;